/**
 * @generated SignedSource<<d198f830a744f3665bced961d484e35b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "version"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "version",
        "variableName": "version"
      }
    ],
    "concreteType": "Impulse",
    "kind": "LinkedField",
    "name": "stubImpulse",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "number",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseImplStubMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseImplStubMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ff67f788c0cbae0e2fb7951ee32921d4",
    "id": null,
    "metadata": {},
    "name": "ImpulseImplStubMutation",
    "operationKind": "mutation",
    "text": "mutation ImpulseImplStubMutation(\n  $id: String\n  $version: Int\n) {\n  stubImpulse(id: $id, version: $version) {\n    id\n    version\n    number\n  }\n}\n"
  }
};
})();

node.hash = "87d3dea121d4e0719ec17e2a0256d250";

module.exports = node;
